/**
 * @generated SignedSource<<ee2c89d847748868ed6cb4650c2b9039>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserSegmentationRedirect_fragment$data = {
  readonly jira_userSegRedirectAdvice: {
    readonly redirect: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "UserSegmentationRedirect_fragment";
};
export type UserSegmentationRedirect_fragment$key = {
  readonly " $data"?: UserSegmentationRedirect_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSegmentationRedirect_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "accountId"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "UserSegmentationRedirect_fragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "accountId"
        },
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraUserSegRedirectAdvice",
      "kind": "LinkedField",
      "name": "jira_userSegRedirectAdvice",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "redirect"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "e97a1130d45ff78da3f6db7ae68eba45";

export default node;
